import { Component, OnInit, OnDestroy } from '@angular/core';
import { LanguageService } from './core/services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Tenjah School Management';
  isLoadingTranslations = true; // Start as loading
  private loadingSubscription?: Subscription;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    // Subscribe to translation loading state from LanguageService
    // This will track both initial load and language switches
    this.loadingSubscription = this.languageService.isLoadingTranslations$.subscribe(
      isLoading => {
        this.isLoadingTranslations = isLoading;
        console.log(`[AppComponent] Translation loading state: ${isLoading}`);
      }
    );
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
